import { Box, Button, Grid2 } from "@mui/material";
import React, { useState, useEffect } from "react";
import SideBar from "../SideBar/SideBar";
import { useTheme, useMediaQuery } from "@mui/material";
import '../Assistant/Assistant.css';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import Modal from '@mui/material/Modal';
import Stack from "@mui/material/Stack";
import Typography from '@mui/material/Typography';
import TextField from "@mui/material/TextField";
import DeleteIcon from '@mui/icons-material/Delete';
import { ToastContainer, toast } from 'react-toastify';
import { Link, useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid2";
import Avatar from "@mui/material/Avatar";
import upload from "../../Images/upload.svg";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import { styled } from "@mui/material/styles";
import './EditProfile.css'
import OutlinedInput from "@mui/material/OutlinedInput";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import IconButton from "@mui/material/IconButton";
import Collapse from "@mui/material/Collapse";
import HighlightOffIcon from '@mui/icons-material/HighlightOff';

const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1,
});

const drawerWidth = 300;
const EditProfile = () => {
    const notify = () => toast.success('Password Updated');
    const remove = () => toast.success('Deleted successfully');

    const theme = useTheme();
    const isLgUp = useMediaQuery(theme.breakpoints.up("sm"));

    const [pop, setPop] = useState(false);
    const handlePopOpen = () => setPop(true);
    const handlePopClose = () => setPop(false);

    const [pop1, setPop1] = useState(false);
    const handlePopOpen1 = () => setPop1(true);
    const handlePopClose1 = () => setPop1(false);

    const [pop2, setPop2] = useState(false);
    const handlePopOpen2 = () => setPop2(true);
    const handlePopClose2 = () => setPop2(false);

    const navigate = useNavigate();

    //   image upload
    const [state, setState] = useState("");
    const handleChange = (event) => {
        setState(event.target.value);
    };
    const [imageUrl, setImageUrl] = useState(null);
    const [profileImage, setProfileImage] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const handleImageUpload = (event) => {
        const file = event.target.files[0];
        const reader = new FileReader();

        setProfileImage(file);
        reader.onloadend = () => {
            setImageUrl(reader.result);
        };

        if (file) {
            reader.readAsDataURL(file);
        }
    };
    //   password
    const [password, setPassword] = useState();
    const [showPassword, setShowPassword] = React.useState(false);

    const handleClickShowPassword = () => setShowPassword((show) => !show);
  
    const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);

    const handleClickConfirmShowPassword = () =>
        setShowConfirmPassword((show) => !show);

    const [confPassErr, setConfPassErr] = useState("");

    const checkconfirmpass = (e) => {
        if (password != e) {
            setConfPassErr("Password Mismatching");
        } else {
            setConfPassErr("");
        }
    };

    const [sameMap, setsameMap] = React.useState(false);
    const [expandedMap, setExpandedMap] = React.useState(false);

    const handleExpandClickMap = () => {
        setsameMap(false);
        setExpandedMap(!expandedMap);
    };
    const handleExpandClickSameMap = () => {
        setExpandedMap(false);
        setsameMap(!sameMap);
    };
    return (
        <div className="EditProfile">
            <Box sx={{ display: isLgUp ? "flex" : "block", marginTop: "20px" }}>
                <SideBar />

                <Box
                    component="main"
                    sx={{
                        flexGrow: 1,
                        p: isLgUp ? 5 : 1,
                        width: { sm: `calc(100% - ${drawerWidth}px)` },
                        marginTop: isLgUp ? "0px" : "80px",
                    }}
                >
                    <Grid2 container spacing={2}>
                        <Grid2
                            item
                            size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                            className="mb-20"
                        >
                            <div className="create-assitant">
                                <h1>Create Your First AI Voice Assistant</h1>
                                <p>
                                    Rorem ipsum dolor sit amet, consectetur adipiscing elit.Rorem
                                    ipsum dolor sit amet, consectetur adipiscing elit.
                                </p>

                                <div className="modal-popup">
                                    <div className="graient-btn mt-30">
                                        <Button className="display-1" onClick={handlePopOpen}>CREATE AN AI VOICE ASSISTANT<AutoAwesomeIcon /></Button>
                                    </div>
                                    <Modal
                                        open={pop}
                                        onClose={handlePopClose}
                                        aria-labelledby="modal-modal-title"
                                        aria-describedby="modal-modal-description"
                                    >
                                        <Box className="common-modal-box EditProfile-popup">
                                            <div className="">
                                                <form>
                                                <Grid container spacing={1} sx={{ display: "flex", mt: "20px", justifyContent: "center", }}>
                                                    <Grid item size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} sx={{ justifyContent: "center", textAlign: 'center' }}>
                                                        <div className="profile-upload">
                                                            <Avatar
                                                                alt="Remy Sharp"
                                                                src={imageUrl ? imageUrl : upload}
                                                            />
                                                            <Button
                                                                component="label"
                                                                role={undefined}
                                                                tabIndex={-1}
                                                                startIcon={<CameraAltIcon />}
                                                                className="pencil-icon"
                                                            >
                                                                <VisuallyHiddenInput
                                                                    type="file"
                                                                    onChange={handleImageUpload}
                                                                />
                                                            </Button>
                                                        </div>
                                                    </Grid>
                                                    <Grid item size={{ xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }} sx={{ justifyContent: "center" }}>
                                                        <div className="input-common">
                                                            <label>First Name *</label>
                                                            <TextField fullWidth id="fullWidth" placeholder="Enter First Name" />
                                                        </div>
                                                    </Grid>
                                                    <Grid item size={{ xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }} sx={{ justifyContent: "center" }}>
                                                        <div className="input-common">
                                                            <label>Last Name *</label>
                                                            <TextField fullWidth id="fullWidth" placeholder="Enter Last Name" />
                                                        </div>
                                                    </Grid>
                                                    <Grid item size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} sx={{ justifyContent: "center" }}>
                                                        <div className="input-common">
                                                            <label>Email *</label>
                                                            <TextField fullWidth id="fullWidth" placeholder="@gmail.com" />
                                                        </div>
                                                    </Grid>


                                                    <Grid item size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} sx={{ justifyContent: "center" }}>
                                                        <div className="input-common">
                                                            <label>Password</label>
                                                            <FormControl
                                                                sx={{ mt: 1, width: "100%" }}
                                                                variant="outlined"
                                                            >
                                                                <OutlinedInput
                                                                    id="outlined-adornment-password"
                                                                    type={showPassword ? "text" : "password"}
                                                                    value={password}
                                                                    placeholder="********"
                                                                    onChange={(e) => {
                                                                        setPassword(e.target.value);
                                                                    }}
                                                                    endAdornment={
                                                                        <InputAdornment position="end">
                                                                            <IconButton className="eye-icon"
                                                                                aria-label={
                                                                                    showPassword
                                                                                        ? "hide the password"
                                                                                        : "display the password"
                                                                                }
                                                                                onClick={handleClickShowPassword}
                                                                                edge="end"
                                                                            >
                                                                                {showPassword ? (
                                                                                    <Visibility />
                                                                                ) : (
                                                                                    <VisibilityOff />
                                                                                )}
                                                                            </IconButton>
                                                                        </InputAdornment>
                                                                    }
                                                                />
                                                            </FormControl>
                                                        </div>

                                                        <div className="reg-forget mt-10 display-4">
                                                            <Link onClick={handleExpandClickMap}>
                                                                Change Password
                                                            </Link>
                                                        </div>
                                                    </Grid>

                                                    <Collapse in={expandedMap} timeout="auto" unmountOnExit>
                                                        <Grid item size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} sx={{ justifyContent: "center" }}>

                                                            <Grid container spacing={1}>
                                                                <Grid item size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} sx={{ justifyContent: "center" }}>
                                                                    <div className="input-common">
                                                                        <label>Old Password *</label>
                                                                        <FormControl
                                                                            sx={{ mt: 1, width: "100%" }}
                                                                            variant="outlined"
                                                                        >
                                                                            <OutlinedInput
                                                                                id="outlined-adornment-password"
                                                                                type={showPassword ? "text" : "password"}
                                                                                value={password}
                                                                                placeholder="********"
                                                                                onChange={(e) => {
                                                                                    setPassword(e.target.value);
                                                                                }}
                                                                                endAdornment={
                                                                                    <InputAdornment position="end">
                                                                                        <IconButton className="eye-icon"
                                                                                            aria-label={
                                                                                                showPassword
                                                                                                    ? "hide the password"
                                                                                                    : "display the password"
                                                                                            }
                                                                                            onClick={handleClickShowPassword}
                                                                                            edge="end"
                                                                                        >
                                                                                            {showPassword ? (
                                                                                                <Visibility />
                                                                                            ) : (
                                                                                                <VisibilityOff />
                                                                                            )}
                                                                                        </IconButton>
                                                                                    </InputAdornment>
                                                                                }
                                                                            />
                                                                        </FormControl>
                                                                    </div>
                                                                </Grid>
                                                                <Grid item size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} sx={{ justifyContent: "center" }}>
                                                                    <div className="input-common">
                                                                        <label>New Password *</label>
                                                                        <FormControl
                                                                            sx={{ mt: 1, width: "100%" }}
                                                                            variant="outlined"
                                                                        >
                                                                            <OutlinedInput
                                                                                id="outlined-adornment-password"
                                                                                type={showPassword ? "text" : "password"}
                                                                                value={password}
                                                                                placeholder="********"
                                                                                onChange={(e) => {
                                                                                    setPassword(e.target.value);
                                                                                }}
                                                                                endAdornment={
                                                                                    <InputAdornment position="end">
                                                                                        <IconButton className="eye-icon"
                                                                                            aria-label={
                                                                                                showPassword
                                                                                                    ? "hide the password"
                                                                                                    : "display the password"
                                                                                            }
                                                                                            onClick={handleClickShowPassword}
                                                                                            edge="end"
                                                                                        >
                                                                                            {showPassword ? (
                                                                                                <Visibility />
                                                                                            ) : (
                                                                                                <VisibilityOff />
                                                                                            )}
                                                                                        </IconButton>
                                                                                    </InputAdornment>
                                                                                }
                                                                            />
                                                                        </FormControl>
                                                                    </div>
                                                                </Grid>
                                                                <Grid item size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} sx={{ justifyContent: "center" }}>
                                                                    <div className="input-common">
                                                                        <label>Confirm Password *</label>
                                                                        <FormControl
                                                                            sx={{ mt: 1, width: "100%" }}
                                                                            variant="outlined"
                                                                        >
                                                                            <OutlinedInput
                                                                                id="outlined-adornment-password"
                                                                                type={showPassword ? "text" : "password"}
                                                                                value={password}
                                                                                placeholder="********"
                                                                                onChange={(e) => {
                                                                                    setPassword(e.target.value);
                                                                                }}
                                                                                endAdornment={
                                                                                    <InputAdornment position="end">
                                                                                        <IconButton className="eye-icon"
                                                                                            aria-label={
                                                                                                showPassword
                                                                                                    ? "hide the password"
                                                                                                    : "display the password"
                                                                                            }
                                                                                            onClick={handleClickShowPassword}
                                                                                            edge="end"
                                                                                        >
                                                                                            {showPassword ? (
                                                                                                <Visibility />
                                                                                            ) : (
                                                                                                <VisibilityOff />
                                                                                            )}
                                                                                        </IconButton>
                                                                                    </InputAdornment>
                                                                                }
                                                                            />
                                                                        </FormControl>
                                                                    </div>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    </Collapse>



                                                </Grid>
                                                </form>
                                            </div>

                                            <Stack direction="row" spacing={2} sx={{ justifyContent: "center" }}>
                                                <div className="border-graient mt-10">
                                                    <Button>Cancel</Button>
                                                </div>
                                                <div className="border-graient mt-10">
                                                    <Button onClick={notify}>Save</Button>

                                                </div>
                                            </Stack>
                                        </Box>
                                    </Modal>
                                </div>
                            </div>
                        </Grid2>
                    </Grid2>
                </Box>

            </Box>
            <ToastContainer position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick={false}
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
            />
        </div>
    )
}

export default EditProfile